import { api } from "@/api/client";
import { Project } from "./project";
import { SubProject } from "./subProject";

export type Datasheet = {
  datasheetId: string;
  subProjectId: string;
  datasheetName: string;
};

export type ScanDatasheetResponse = {
  project: Project;
  subProject: SubProject;
  datasheet: Datasheet;
};

export function getDatasheetsBySubProject(subProjectId?: string) {
  return api.get<Datasheet[]>(`datasheets?subProjectId=${subProjectId}`);
}

export function getDatasheet(datasheetId?: string) {
  return api.get<Datasheet>(`datasheets/${datasheetId}`);
}

export function scanDatasheet(datasheetId: string) {
  return api.post<ScanDatasheetResponse>(`datasheets/scan?barcode=${datasheetId}`);
}
